import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const forItems = ['Artesãs que já vendem ou querem vender lembrancinhas', 'Quem quer cobrar mais sem mudar o produto, só a apresentação', 'Quem não tem formação em design mas quer resultado profissional', 'Decoradoras e assessoras que querem profissionalizar suas sugestões'];
const notForItems = ['Quem busca uma fórmula mágica sem precisar aplicar nada', 'Quem quer aprender a fazer produtos do zero (aqui ensinamos a apresentar)', 'Quem já aplica o Efeito Boutique™ e domina a curadoria visual'];
export function ForWhomSection() {
  return <section className="py-8 md:py-12 bg-white" data-id="element-145">
      <div className="max-w-3xl mx-auto px-5" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-6" data-id="element-147">
          <h2 className="text-2xl md:text-3xl font-bold text-stone-900 leading-tight" data-id="element-148">
            Para quem é o{' '}
            <span className="text-brand-600" data-id="element-149">Efeito Boutique™</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-150">
          {/* Para quem é */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-green-50/60 border border-green-200/60 rounded-2xl p-5 md:p-6" data-id="element-151">
            <p className="font-bold text-green-700 text-sm mb-4 tracking-wide uppercase" data-id="element-152">
              ✅ Para quem é
            </p>
            <ul className="space-y-3" data-id="element-153">
              {forItems.map((item, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-154">
                  <div className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-155">
                    <Check className="w-3 h-3 text-green-600" strokeWidth={3} data-id="element-156" />
                  </div>
                  <span className="text-sm text-stone-700 leading-relaxed" data-id="element-157">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Para quem NÃO é */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-stone-50 border border-stone-200/60 rounded-2xl p-5 md:p-6" data-id="element-158">
            <p className="font-bold text-stone-500 text-sm mb-4 tracking-wide uppercase" data-id="element-159">
              ✗ Para quem NÃO é
            </p>
            <ul className="space-y-3" data-id="element-160">
              {notForItems.map((item, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-161">
                  <div className="w-5 h-5 rounded-full bg-stone-200 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-162">
                    <X className="w-3 h-3 text-stone-400" strokeWidth={3} data-id="element-163" />
                  </div>
                  <span className="text-sm text-stone-500 leading-relaxed" data-id="element-164">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}